import { createSelector } from 'reselect';

import { RootState } from 'store/types';

export const initializedBookingSelector = (state: RootState) =>
  state.booking.appointment.initializedBookingInformation;

export const initBookingRequestStateSelector = createSelector(
  initializedBookingSelector,
  init => init.requestState
);
